import { Poppins, Quicksand } from 'next/font/google';
import Link from 'next/link';
import React from 'react'
const popins = Poppins({weight:['500','600','700'],subsets:['latin'],display:'swap',preload:true});

export default function RelatedCourses({relatedCourse,location1,url1,title}) {

  return (
    <>
    <section className={`whole-pdtb`} style={{background:'#FEE9BF'}}>
     <div className={`container`}>
     <h5 className={`fs-30 tfs-28 mfs-21 fwb600 ${popins?.className || ""}`}>
      Related Courses
      to <span className="ylw-clr">{` ${title}`}</span>
    </h5>
    
     <div className='df fw gap5 mt32 tmt28 mmt24 '>
  
      {relatedCourse.map((items,id)=>(         
          <Link href={`${items.relatedpath}${url1}`} key={id}>
          <div className='related-box mt5'>
        <p className={`fs-14 mfs-12 fwb500 ${popins.className}`}>{`${items.relatedtraining} ${location1 ? `${location1}` : " "}`} </p>
          </div>
        </Link>
      ))}
    
     </div>
     </div>
    </section>
    </>
  )
}
